module.exports = __webpack_public_path__ + "static/media/01_Citation_Set_AR_icon_preview.247beeb9.png";